export default __webpack_public_path__ + "static/media/zbyg4.b5994075.png";